<template>
  <v-dialog v-model="visible" max-width="70%">
    <v-card mt-1>
      <v-progress-linear height="3px"
                         v-show="caseResults.loading" color="primary" indeterminate></v-progress-linear>
      <v-card-title>{{ itemDetail.displayId }} {{itemDetail.customer.name}} 申覆紀錄</v-card-title>


      <v-card-text>
        <span v-if="caseResults.list.length === 0">無紀錄</span>
        <div v-for="(item, i) in caseResults.list" :key="i">
          <v-layout column wrap>
            <v-flex v-if="item.createdDate">
             <span class="subheading">
                回覆時間：{{ item.createdDate }}
              </span>
            </v-flex>
            <v-flex v-if="item.content">
               <span>
                 {{ item.content }}
              </span>
            </v-flex>
            <v-flex v-if="item.fileURL">
              <a :href="item.fileURL" target="_blank">申覆檔案</a>
            </v-flex>
            <v-divider></v-divider>
          </v-layout>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="closeEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ExamView',
  props: {
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      messageDialog: {
        visible: false,
        title: '',
        content: '',
      },
      caseResults: {
        loading: false,
        list: [],
      },
      saveResultLoading: false,
      selectQuestion: null,
    };
  },
  watch: {
    visible(value) {
      console.log(`examDialog visible = ${value}`);
      if (value === true) {
        this.loadData();
      }
    },
  },
  created() {

  },
  methods: {
    ...mapActions(['fetchExamList']),
    async loadData() {
      console.log(`fetchExamList displayId === ${this.itemDetail.displayId}`);

      this.caseResults.loading = true;
      const res = await this.fetchExamList({ displayId: this.itemDetail.displayId });
      const result = res.data;
      console.log(`fetchExamList result ${JSON.stringify(result)}`);
      this.caseResults.loading = false;
      if (result.statusCode === 0) {
        if (result.data) {
          this.caseResults.list = result.data.list;
        } else {
          this.caseResults.list = [];
        }
      }
    },
    showDialog(visible, title, content) {
      this.messageDialog.visible = visible;
      this.messageDialog.title = title;
      this.messageDialog.content = content;
    },
    dialogConfirmEvent() {
      this.messageDialog.visible = false;
    },
    closeEvent() {
      this.$emit('closeEvent', true);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ExamView.vue